import Link from "next/link";
import Icon from "../Icon";
import React from "react";
import {IMagazineEntry} from "../../interfaces/IMagazine";
import styled from "styled-components";
import {getTheme} from "../../shared/themeUtils";

const Entry = styled.div`
    background: ${getTheme("colors.background")};
    border-radius: ${getTheme("space.1")};
    padding: 0;
    cursor: pointer;
    margin-bottom: ${getTheme("space.3")};

    .topic-link {
        color: ${getTheme("colors.secondaryFont")};
        position: relative;
        left: ${getTheme("space.2")};
        top: ${getTheme("space.2")};
        font-size: ${getTheme("fontSizes.small")};

        &:hover {
            color: ${getTheme("colors.link")};
        }
    }
    .section-title {
        background: ${getTheme("colors.darkestGrey")};
        text-align: right;
        font-size: ${getTheme("fontSizes.small")};
        padding: ${getTheme("space.0")} ${getTheme("space.1")};
    }

    .image img {
        border-top-left-radius: ${getTheme("space.1")};
        border-top-right-radius: ${getTheme("space.1")};
        width: 100%;
    }

    .text {
        padding: ${getTheme("space.2")};

        .title {
            font-size: ${getTheme("fontSizes.xLarge")};
        }
        .date {
            font-size: ${getTheme("fontSizes.small")};
            color: ${getTheme("colors.secondaryFont")};
            margin-top: ${getTheme("space.1")};
            display: flex;
            align-items: center;

            .clock-icon {
                display: inline-block;
                margin-right: ${getTheme("space.1")};
                opacity: .6;
            }
        }
    }

`

type MagazineListingEntryPropsType = {
  entry: IMagazineEntry,
  sections?: any,
  topics?: object
}

export default function MagazineListingEntry(props: MagazineListingEntryPropsType) {
  const {entry, sections, topics} = props;

  const sectionIDKey = entry.sectionId?.toString();
  const sectionTitle = sectionIDKey && sections ? sections[sectionIDKey] : undefined;

  const handleTopicClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (entry.topicLink) {
      window.location.href = entry.topicLink.href;
    }
  };

  return (
    <Link href={entry.link} passHref>
      <Entry>
        <div className="image">
          <img src={entry.imageURI} alt={entry.featureText}/>
        </div>
        {sectionTitle && <div className="section-title text-muted">{sectionTitle.toString()}</div>}
        {entry.topicLink && (
          <span className="topic-link" onClick={handleTopicClick}>
            {entry.topicLink.title}
          </span>
        )}
        <div className="text">
          <div className="title" dangerouslySetInnerHTML={{__html: entry.featureText}}/>
          <div className="date">
            <Icon className={"clock-icon"} color={"secondaryFont"} variant="small">time-line</Icon>
            {entry.entryDate}
          </div>
        </div>
      </Entry>
    </Link>
  )
}